// extracted by mini-css-extract-plugin
module.exports = {"container":"Notifications_container__3HAU1","description":"Notifications_description__3-aAc"};